import React, { useState, useEffect , useRef } from "react";
import { Form, Row, Col } from "react-bootstrap";
import DropdownComponent from "../../../../../components/UI_Kit/Dropdown/Dropdown";
import Skeleton from "react-loading-skeleton"; // Import Skeleton
import "react-loading-skeleton/dist/skeleton.css"; // Import skeleton CSS

// Helper to generate a unique and valid controlId from the field name
const generateControlId = (fieldName) => {
  return fieldName.replace(/\s+/g, '-').toLowerCase(); // e.g., "type-du-support"
};

const TypeThreeForm = ({ // Renamed component
  config, // Added config prop
  type3Data,
  handleChange,
  fileInputRef,
  handlePhotoUpload,
  showMenu,
  setShowMenu,
  handleOpenModal,
  handleDeletePhoto,
  isUploading
}) => {
    // Create a new ref for the gallery input
  const galleryInputRef = useRef(null);
  
  // Add state to track if the device is mobile
  const [isMobileDevice, setIsMobileDevice] = useState(false);
  
  // Detect if the device is mobile
  useEffect(() => {
    const checkIfMobile = () => {
      // Check for touch capability as primary indicator
      const hasTouchScreen = (
        'ontouchstart' in window || 
        navigator.maxTouchPoints > 0 ||
        navigator.msMaxTouchPoints > 0
      );
      
      // Check for mobile user agent as secondary indicator
      const mobileUserAgent = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
      
      // Check screen width as tertiary indicator
      const smallScreen = window.innerWidth <= 768;
      
      // Consider a device mobile if it has touch capability AND (mobile user agent OR small screen)
      setIsMobileDevice(hasTouchScreen && (mobileUserAgent || smallScreen));
    };
    
    checkIfMobile();
    
    // Re-check on window resize
    window.addEventListener('resize', checkIfMobile);
    
    return () => {
      window.removeEventListener('resize', checkIfMobile);
    };
  }, []);

  // Mapping from config field names to state keys in type3Data
  const fieldNameToStateKeyMap = {
    "Type du support": "supportType",
    "Type de Liaison": "installationType",
    "Type d'Alimentation": "powerSupplyType",
    // Add other mappings if high_point has different/more fields in config
    // Note: "Zone de couverture" is handled separately below
  };

  return (
    <>
      {/* Point Name - Remains unchanged */}
      <Row >
        <Col>
          <Form.Group controlId="pointName">
            <Form.Label>Nom du point*</Form.Label>
            <Form.Control
              name="pointName"
              value={type3Data.pointName}
              onChange={handleChange}
              placeholder="Nommer le point"
            />
          </Form.Group>
        </Col>
      </Row>

      {/* Location/Photos - Remains unchanged */}
      <Row className="mb-4 mt-4">
        <Col>
          <Form.Group controlId="location">
            <Form.Label>Localisation*</Form.Label>
            <div className="photo-upload-options">
              {/* Only show camera option on mobile devices */}
              {isMobileDevice && (
                <div
                  className="photo-upload-box"
                  onClick={() => fileInputRef.current.click()}
                >
                  <span className="photo-upload-placeholder">
                    <img src="/camera.png" alt="Camera"></img> Prendre une photo
                  </span>
                </div>
              )}
              <div
                className={`photo-upload-box ${!isMobileDevice ? 'full-width' : ''}`}
                onClick={() => galleryInputRef.current.click()}
              >
                <span className="photo-upload-placeholder">
                  <img src="/camera.png" alt="Gallery"></img> Choisir depuis la galerie
                </span>
              </div>
            </div>
            <Form.Control
              ref={fileInputRef}
              type="file"
              name="photo"
              accept="image/*"
              onChange={handlePhotoUpload}
              multiple
              hidden
              capture="environment"
            />
            <Form.Control
              ref={galleryInputRef}
              type="file"
              name="photo"
              accept="image/*"
              onChange={handlePhotoUpload}
              multiple
              hidden
            />
            
            <div className="photo-preview-list">
              {type3Data.photos?.map((photo, index) => (
                <div key={index} className="photo-preview-item">
                  <div className="photo-preview-image-container">
                    <img
                      src={photo.url}
                      alt="Uploaded"
                      className="photo-preview-image"
                    />
                  </div>
                  <div className="photo-details">
                    <strong className="photo-title">
                      Localisation_Vue {index + 1}
                    </strong>
                    <span className="photo-name">
                      <img src="/picture-icon.png" className="location-icon" alt="PIC NAME"></img>{" "}
                      {/* Limit photo name to 10 characters and add ellipsis if truncated */}
                      {photo.name ? (photo.name.length > 10 ? photo.name.substring(0, 10) + '...' : photo.name) : ''}
                    </span>
                    <span className="photo-meta">
                      <img src="/location-icon.png" className="location-icon" alt="PIC METADATA"></img>{" "}
                      {/* Limit photo location to 20 characters and add ellipsis if truncated */}
                      {photo.location ? (photo.location.length > 20 ? photo.location.substring(0, 20) + '...' : photo.location) : "Pas de localisation"}
                    </span>
                  </div>
                  <div className="photo-actions">
                    <span
                      className="photo-options-btn"
                      onClick={() =>
                        setShowMenu(showMenu === index ? null : index)
                      }
                    >
                      ⋮
                    </span>
                    {showMenu === index && (
                      <div className="custom-dropdown-menu">
                        <div className="dropdown-arrow" />
                        <button
                          className="custom-dropdown-item"
                          onClick={() => {
                            handleOpenModal(index);
                            setShowMenu(null);
                          }}
                        >
                          <img src="/edit_alt.png" className="action-icon" alt="EDIT"></img> {" "}
                          Modifier
                        </button>
                        <button
                          className="custom-dropdown-item"
                          onClick={() => {
                            handleDeletePhoto(index);
                            setShowMenu(null);
                          }}
                        >
                          <img src="/close.png" className="action-icon" alt="DELETE"></img> {" "}
                          Supprimer
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              ))}
              {isUploading && (
                <div className="photo-preview-item">
                  <div className="photo-preview-image-container">
                    <Skeleton circle={false} height={100} width={100} />
                  </div>
                  <div className="photo-details">
                    <Skeleton width={100} />
                    <Skeleton width={150} />
                    <Skeleton width={120} />
                  </div>
                  <div className="photo-actions">
                    <Skeleton circle={true} height={20} width={20} />
                  </div>
                </div>
              )}
            </div>
          </Form.Group>
        </Col>
      </Row>

      {/* Dynamically generated select fields */}
      {config?.fields && Object.entries(config.fields).map(([fieldName, options]) => {
        const stateKey = fieldNameToStateKeyMap[fieldName];
        const controlId = generateControlId(fieldName);

        // Only render if we have a mapping for the field name to a state key
        // or if the fieldName is "Zone de couverture" which has its own state key
        if (!stateKey && fieldName !== "Zone de couverture") {
          console.warn(`No state key mapping found for config field: ${fieldName} in TypeThreeForm`);
          return null; // Skip rendering this field
        }

        // Use 'coverageArea' as stateKey for "Zone de couverture"
        const currentName = fieldName === "Zone de couverture" ? "coverageArea" : stateKey;
        const currentValue = fieldName === "Zone de couverture" ? type3Data.coverageArea : type3Data[stateKey];

        return (
          <Row className="mb-3" key={controlId}>
            <Col>
              <Form.Group controlId={controlId}>
                <Form.Label>{fieldName}*</Form.Label> {/* Use fieldName as label */}
                <DropdownComponent
                  name={currentName} // Use the mapped state key or 'coverageArea'
                  value={currentValue} // Access value using the mapped state key or 'coverageArea'
                  onChange={handleChange}
                  options={options}
                  placeholder="Sélectionner..."
                />
              </Form.Group>
            </Col>
          </Row>
        );
      })}

      {/* Coverage Area - Remains specific to this form - THIS SECTION CAN NOW BE REMOVED IF "Zone de couverture" is always in config.fields */}
      {/* 
      <Row className="mb-3">
        <Col>
          <Form.Group controlId="coverageArea">
            <Form.Label>Zone de couverture*</Form.Label>
            <Form.Control
              name="coverageArea"
              value={type3Data.coverageArea}
              onChange={handleChange}
              placeholder="Définir la zone de couverture"
              required
            />
          </Form.Group>
        </Col>
      </Row>
      */}

      {/* Comment  */}
      <Row >
        <Col>
          <Form.Group controlId="comment">
            <Form.Label>Commentaire</Form.Label>{" "}
            <Form.Control
              as="textarea"
              name="comment"
              value={type3Data.comment}
              onChange={handleChange}
              placeholder="Ajouter un commentaire..."
              maxLength={300}
              className="comment-box"
            />
            <div className="char-counter">{type3Data.comment?.length || 0}/300</div>
          </Form.Group>
        </Col>
      </Row>
    </>
  );
};

export default TypeThreeForm; // Updated export name
